import React from 'react';
import { FiGithub } from 'react-icons/fi';
import { BiLinkExternal } from 'react-icons/bi';
import pro1 from '../../../Assets/Screenshot (397).png'
import pro2 from '../../../Assets/Screenshot (398).png'
import pro3 from '../../../Assets/Screenshot (399).png'
import './Projects.css'

const Projects = () => {
    return (
        <div className='lg:mt-10 pt-28 md:mt-5 px-5 md:px-10 lg:px-0 w-screen lg:w-full' id='work'>
            <div className='text-3xl md:text-4xl flex'>
                <h3 className='numbered-heading-project font-bold headline-style lg:ml-0' >Some Of My Best Projects</h3>
            </div>


            <div className="projects mt-10">
                {/* projects 1 */}
                <div className='hidden lg:flex mt-20 mb-36 items-center text-right relative'>
                    <div className='w-7/12' >
                        <div className='container'>
                            <div className="box box1"></div>
                        </div>
                    </div>
                    <div className='w-5/12 ml-6' >
                        <h4 className='text-lg font-mono mb-2 text-sky-500'>Featured Project</h4>
                        <h2 className='text-4xl font-semibold mb-5'>ScheduPlannr</h2>
                        <div className='div-styles  text-gray-700 p-5 text-lg rounded-xl absolute right-0 w-6/12'>
                            <p>
                                ScheduPlannr a <span className='font-semibold text-sky-500'>Team Project. </span> This is a schedule making and managing website. By using this user can create schedule for meetings, class and other nassesary events.
                            </p>
                        </div>
                        <div className='mt-44 text-base flex justify-end gap-8 font-semibold '>
                            <span className=''>Typescript</span>
                            <span className=''>React</span>
                            <span className=''>Node.js</span>
                            <span className=''>Express.js</span>
                            <span className=''>Tailwind</span>
                        </div>
                        <div className='flex justify-end items-center mt-5 text-2xl'>
                            <a href="https://github.com/asifsikder23/ScheduPlannr-client" target="_blank" rel="noreferrer" className='hover:text-sky-600'><FiGithub className='mr-3' /></a>
                            <a href="https://schedu-plannr.web.app/" target="_blank" rel="noreferrer" className='hover:text-sky-600'><BiLinkExternal /></a>
                        </div>
                    </div>
                </div>

                <div className='mt-20 mb-20 items-center relative lg:hidden' >
                    <h4 className='text-sm font-mono mb-2 mt-5 text-sky-500' >Featured Project</h4>
                    <h2 className='text-2xl font-semibold mb-5' >ScheduPlannr</h2>
                    <div className='w-full' >
                        <div className='container'>
                            <div className="box box1"></div>
                        </div>
                    </div>
                    <div className='w-11/12 md:w-full mx-auto lg:w-full mt-5'>
                        <div className='div-styles text-gray-700 p-5 text-base rounded-xl w-full md:text-xl' >
                            <p>
                                ScheduPlannr a <span className='font-semibold text-sky-500'>Team Project. </span> This is a schedule making and managing website. By using this user can create schedule for meetings, class and other nassesary events.
                            </p>
                        </div>
                        <div className='md:flex justify-between md:pl-2'>
                            <div className='text-base flex flex-wrap gap-7 justify-between mt-5 md:gap-10' >
                                <span className='lg:mr-4'>Typescript</span>
                                <span className='lg:mr-4'>React</span>
                                <span className='lg:mr-4'>Node.js</span>
                                <span className='lg:mr-4'>Express.js</span>
                                <span className='lg:mr-4'>Tailwind</span>
                            </div>
                            <div className='flex items-center mt-5 text-2xl' >
                                <a href="https://github.com/asifsikder23/ScheduPlannr-client" target="_blank" rel="noreferrer" className='hover:text-sky-600'><FiGithub className='mr-3' /></a>
                                <a href="https://schedu-plannr.web.app/" target="_blank" rel="noreferrer" className='hover:text-sky-600'><BiLinkExternal /></a>
                            </div>
                        </div>
                    </div>
                </div>

                {/* projects 2 */}
                <div className='mt-20 mb-36 hidden lg:flex items-center text-right relative'>
                    <div className='w-5/12 mr-6'>
                        <h4 className='text-lg text-left font-mono mb-2 text-sky-500' >Featured Project</h4>
                        <h2 className='text-4xl font-semibold mb-5 text-left ' >B-Picker</h2>
                        <div className='div-styles text-gray-700 p-5 text-lg text-left rounded-xl absolute left-0 w-6/12 ' >
                            <p>
                                B-Picker is a book reseller shop. User can sell their old books and also buy books from this site. Also seller can create advertise for their newly added books.
                            </p>
                        </div>
                        <div className='mt-44 text-base flex justify-start gap-8 font-semibold text-left  ' >
                            <span className=''>React</span>
                            <span className=''>Node.Js</span>
                            <span className=''>Express.Js</span>
                            <span className=''>MongoDB</span>
                            <span className=''>Tailwind</span>
                        </div>
                        <div className='flex justify-start items-center mt-5 text-2xl' >
                            <a href="https://github.com/Syeda-Aisha-Ahmad/b-picker_client_repo" target="_blank" rel="noreferrer" className='hover:text-sky-600'><FiGithub className='mr-3' /></a>
                            <a href="https://b-picker-e010a.web.app/" target="_blank" rel="noreferrer" className='hover:text-sky-600'><BiLinkExternal /></a>
                        </div>
                    </div>

                    <div className='w-7/12 ml-auto'>
                        <div className='container'>
                            <div className="box box2 ml-auto"></div>
                        </div>
                    </div>
                </div>

                <div className='mt-5 mb-20 items-center relative lg:hidden'>
                    <h4 className='text-sm font-mono mb-2 mt-5 text-sky-500'>Featured Project</h4>
                    <h2 className='text-2xl font-semibold mb-5'>B-Picker</h2>
                    <div className='w-full'>
                        <div className='container'>
                            <div className="box box2"></div>
                        </div>
                    </div>
                    <div className='w-full mt-5'>
                        <div className='div-styles text-gray-700 p-5 text-base md:text-xl rounded-xl w-full mx-auto'>
                            <p>
                                B-Picker is a book reseller shop. User can sell their old books and also buy books from this site. Also seller can create advertise for their newly added books.
                            </p>
                        </div>

                        <div className='md:flex justify-between px-4 md:pl-2'>
                            <div className='text-base flex flex-wrap gap-1 justify-between mt-5 md:gap-10'>
                                <span className='mr-4'>React</span>
                                <span className='mr-4'>Node.Js</span>
                                <span className='mr-4'>Express.Js</span>
                                <span className='mr-4'>MongoDB</span>
                                <span className='mr-4'>Tailwind</span>
                            </div>
                            <div className='flex items-center mt-5 text-2xl'>
                                <a href="https://github.com/Syeda-Aisha-Ahmad/b-picker_client_repo" target="_blank" rel="noreferrer" className='hover:text-sky-600'><FiGithub className='mr-3' /></a>
                                <a href="https://b-picker-e010a.web.app/" target="_blank" rel="noreferrer" className='hover:text-sky-600'><BiLinkExternal /></a>
                            </div>
                        </div>
                    </div>
                </div>

                {/* projects 3 */}
                <div className='mt-20 hidden lg:flex items-center text-right relative'>
                    <div className='w-7/12' >
                        <div className='container'>
                            <div className="box box3"></div>
                        </div>
                    </div>
                    <div className='w-5/12 ml-6'>
                        <h4 className='text-lg mb-2 font-mono text-sky-500'>Featured Project</h4>
                        <h2 className='text-4xl font-semibold mb-5'>Hilink</h2>
                        <div className='div-styles  text-gray-700 p-5 text-lg rounded-xl absolute right-0 w-6/12'>
                            <p>
                                Hilink is designed to make it easy for you to <span className='text-sky-500 font-semibold'>explore exciting destinations around the world</span> , book your travel arrangements, and manage your itinerary all in one place.
                            </p>
                        </div>
                        <div className='mt-44 text-base flex justify-end gap-8 font-semibold'>
                            <span className=''>Next JS</span>
                            <span className=''>Typescript</span>
                            {/* <span className=''></span> */}
                            {/* <span className=''></span> */}
                            <span className=''>Tailwind</span>
                        </div>
                        <div className='flex justify-end items-center mt-5 text-2xl'>
                            <a href="https://github.com/Syeda-Aisha-Ahmad/Hilink" target="_blank" rel="noreferrer" className='hover:text-sky-600'><FiGithub className='mr-3' /></a>
                            <a href="https://hilinkwebsite.netlify.app/" target="_blank" rel="noreferrer" className='hover:text-sky-600'><BiLinkExternal /></a>
                        </div>
                    </div>
                </div>

                <div className='mt-5 mb-36 items-center relative lg:hidden' >
                    <h4 className='text-sm font-mono mb-2 mt-5 text-sky-500'>Featured Project</h4>
                    <h2 className='text-2xl font-semibold mb-5'>Hilink</h2>
                    <div className='w-full'>
                        <div className='container'>
                            <div className="box box3"></div>
                        </div>
                    </div>
                    <div className='w-full mt-5'>
                        <div className='div-styles text-gray-700 p-5 text-base md:text-xl rounded-xl w-full mx-auto'>
                            <p>
                                Hilink is designed to make it easy for you to <span className='text-sky-500 font-semibold'>explore exciting destinations around the world</span> , book your travel arrangements, and manage your itinerary all in one place.
                            </p>
                        </div>

                        <div className='md:flex justify-between md:pl-2 px-4'>
                            <div className='text-base flex mt-5 justify-between md:gap-10 flex-wrap gap-7 '>
                                <span className=''>React</span>
                                <span className=''>Node.Js</span>
                                <span className=''>Express.Js</span>
                                <span className=''>MongoDB</span>
                                <span className=''>Tailwind</span>
                            </div>
                            <div className='flex items-center mt-5 text-2xl'>
                                <a href="https://github.com/Syeda-Aisha-Ahmad/Hilink" target="_blank" rel="noreferrer" className='hover:text-sky-600'><FiGithub className='mr-3' /></a>
                                <a href="https://hilinkwebsite.netlify.app/" target="_blank" rel="noreferrer" className='hover:text-sky-600'><BiLinkExternal /></a>
                            </div>
                        </div>

                    </div>
                </div>
            </div>
        </div>
    );
};

export default Projects;